module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sms",
    class: {
      onMobile: _vm.onMobile
    },
    style: ([_vm.sizeSMS])
  }, [_c('div', {
    staticClass: "closedecoy",
    on: {
      "click": _vm.outsideClick
    }
  }), _vm._v(" "), (_vm.isUserSignedUp && !_vm.isUserSubscribed) ? _c('div', {
    staticClass: "subscribe-view"
  }, [(!_vm.showCardPanel) ? _c('div', {
    staticClass: "intro"
  }, [_vm._m(0), _vm._v(" "), _c('img', {
    staticClass: "cursor-pointer",
    attrs: {
      "src": require('@/assets/closeIcon.svg'),
      "width": "16"
    },
    on: {
      "click": _vm.closeSMS
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.showCardPanel) ? _c('hr') : _vm._e(), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": "",
      "px-0": "",
      "grid-list-lg": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "start-trial": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('h2', {
    staticClass: "_title"
  }, [_vm._v("\n            Start "), _c('br'), _vm._v("\n            Free Trial\n          ")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("30 days")]), _vm._v(" "), _c('li', [_vm._v("Cancel anytime")])])]), _vm._v(" "), (!_vm.showCardPanel) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "pro-plan": ""
    }
  }, [_c('h3', {
    staticClass: "_title"
  }, [_vm._v("Pro")]), _vm._v(" "), _c('div', {
    staticClass: "_subtitle"
  }, [_vm._v("For professional creators & curators")]), _vm._v(" "), _c('span', {
    staticClass: "plan-list"
  }, [_c('v-icon', {
    staticClass: "_check"
  }, [_vm._v("check")]), _vm._v(" "), _c('div', [_vm._v("Ad-free + unlimited uploads")])], 1), _vm._v(" "), _c('span', {
    staticClass: "plan-list"
  }, [_c('v-icon', {
    staticClass: "_check"
  }, [_vm._v("check")]), _vm._v(" "), _c('div', [_vm._v("Keep 100% sales & donations")])], 1), _vm._v(" "), _c('span', {
    staticClass: "plan-list"
  }, [_c('v-icon', {
    staticClass: "_check"
  }, [_vm._v("check")]), _vm._v(" "), _c('div', [_vm._v("SMS texting*")])], 1), _vm._v(" "), _c('span', {
    staticClass: "plan-list"
  }, [_c('v-icon', {
    staticClass: "_check"
  }, [_vm._v("check")]), _vm._v(" "), _c('div', [_vm._v("Get paid to share")])], 1), _vm._v(" "), _c('div', {
    staticClass: "pricing"
  }, [_c('div', {
    staticClass: "_wrapper"
  }, [_c('span', {
    staticClass: "currency"
  }, [_vm._v("$")]), _vm._v(" "), _c('span', {
    staticClass: "cost"
  }, [_vm._v("30")]), _vm._v(" "), _c('span', {
    staticClass: "duration"
  }, [_vm._v("/month")])]), _vm._v(" "), _c('v-btn', {
    staticClass: "trial-btn",
    on: {
      "click": function($event) {
        _vm.showCard()
      }
    }
  }, [_vm._v("Free Trial")])], 1)]) : _vm._e(), _vm._v(" "), (_vm.showCardPanel) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "card-panel": ""
    }
  }, [_c('img', {
    staticClass: "_logo",
    attrs: {
      "src": require('@/assets/ys_logo_primary-black.svg'),
      "width": "80"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "_subtitle mb-3"
  }, [_vm._v("Pro Subscription")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('card', {
    staticClass: "stripe-card",
    class: {
      complete: _vm.complete
    },
    attrs: {
      "stripe": _vm.stripePubkey,
      "options": _vm.options
    },
    on: {
      "change": function($event) {
        _vm.complete = $event.complete
      }
    }
  })], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "addCard-btn",
    attrs: {
      "depressed": "",
      "disabled": false,
      "loading": _vm.addCardLoading
    },
    on: {
      "click": function($event) {
        _vm.paymentMethod()
      }
    }
  }, [_vm._v("\n            Add card to file\n          ")])], 1) : _vm._e()], 1)], 1), _vm._v(" "), (!_vm.showCardPanel) ? _c('div', {
    staticClass: "footnote"
  }, [_vm._v("\n      * SMS costs $0.01 per text\n    ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (!_vm.isUserSignedUp) ? _c('div', {
    staticClass: "creator-signup"
  }, [(!_vm.signUpDone) ? _c('div', {
    staticClass: "join-creator",
    class: {
      digitEntered: _vm.digitEntered
    }
  }, [(_vm.digitEntered) ? _c('div', {
    staticClass: "_title"
  }, [_vm._v("Confirm Your Number")]) : _c('div', {
    staticClass: "_title"
  }, [_vm._v("Join this creator community")]), _vm._v(" "), _c('div', {
    staticClass: "_user"
  }, [_c('user-tag', {
    attrs: {
      "user": _vm.currentUser,
      "showAvatar": "",
      "hideTick": "",
      "hideName": "",
      "fitContent": "",
      "height": "140",
      "width": "140",
      "clickUser": false
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('user-tag', {
    attrs: {
      "user": _vm.currentUser,
      "fitContent": "",
      "showUserType": "",
      "clickUser": false
    }
  })], 1), _vm._v(" "), (_vm.digitEntered) ? _c('div', {
    staticClass: "message"
  }, [_vm._v("\n        You will receive text to this number. This number will also be used\n        when you sign up to other SMS communities\n      ")]) : _c('div', {
    staticClass: "message"
  }, [_vm._v("\n        Enter your phone number to let creator send you text messages from\n        this app. Phone numbers are never shared.\n      ")]), _vm._v(" "), (!_vm.digitEntered) ? _c('div', {
    staticClass: "_tel"
  }, [_c('br'), _vm._v(" "), _c('img', {
    staticClass: "flag",
    attrs: {
      "src": require('@/assets/us_flag.svg'),
      "width": "18"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "digit"
  }, [_vm._v("+ 0 1 (")]), _vm._v(" "), _vm._l((_vm.digitsLen), function(input, idx) {
    return _c('span', {
      key: idx
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.number",
        value: (_vm.telDigits[idx]),
        expression: "telDigits[idx]",
        modifiers: {
          "number": true
        }
      }],
      ref: ("input" + idx),
      refInFor: true,
      staticClass: "digit _num",
      attrs: {
        "type": "text",
        "name": "",
        "id": ("input-" + idx),
        "pattern": "([0-9])",
        "maxlength": "1"
      },
      domProps: {
        "value": (_vm.telDigits[idx])
      },
      on: {
        "keydown": function($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "delete", [8, 46], $event.key)) { return null; }
          _vm.delDigit($event, idx)
        },
        "keyup": function($event) {
          if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
          _vm.submitTel($event)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.telDigits, idx, _vm._n($event.target.value))
        },
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    }), _vm._v(" "), (idx === 2) ? _c('span', {
      staticClass: "digit"
    }, [_vm._v(")")]) : _vm._e(), _vm._v(" "), (idx === 6) ? _c('span', {
      staticClass: "digit"
    }, [_vm._v("-")]) : _vm._e()])
  })], 2) : _c('div', {
    staticClass: "_tel-entered"
  }, [_vm._v(_vm._s(_vm.telFormatted))]), _vm._v(" "), (_vm.digitEntered) ? _c('v-btn', {
    staticClass: "width100",
    attrs: {
      "round": "",
      "dark": "",
      "depressed": ""
    },
    on: {
      "click": function($event) {
        _vm.updatePhoneNo()
      }
    }
  }, [_vm._v("\n        Confirm\n      ")]) : _vm._e(), _vm._v(" "), (_vm.digitEntered) ? _c('h3', {
    staticClass: "cursor-pointer",
    on: {
      "click": function($event) {
        _vm.digitEntered = false
      }
    }
  }, [_vm._v("\n        Update my number\n      ")]) : _vm._e(), _vm._v(" "), (!_vm.digitEntered) ? _c('h3', {
    staticClass: "cursor-pointer",
    on: {
      "click": _vm.closeSMS
    }
  }, [_vm._v("\n        No thanks, I’ll just follow\n      ")]) : _vm._e()], 1) : (_vm.signUpDone) ? _c('div', {
    staticClass: "signup-done"
  }, [_c('img', {
    staticClass: "flag",
    attrs: {
      "src": require('@/assets/convo_icon_light.svg'),
      "width": "22",
      "alt": "conversation icon"
    }
  }), _vm._v(" "), _c('div', [_vm._v("You’ve been added to this SMS list")]), _vm._v(" "), _c('v-btn', {
    staticClass: "done-btn",
    attrs: {
      "depressed": "",
      "round": ""
    },
    on: {
      "click": function($event) {
        _vm.closeSMS()
      }
    }
  }, [_vm._v("Close")])], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (
    !_vm.confirmSendSMS && !_vm.sendSuccess && _vm.isUserSignedUp && _vm.isUserSubscribed
  ) ? _c('div', {
    staticClass: "post-sms"
  }, [(!_vm.confirmSendSMS) ? _c('div', {
    staticClass: "post-sms-card"
  }, [_c('div', {
    staticClass: "post-sms-wrapper"
  }, [(!_vm.onMobile) ? _c('div', {
    staticClass: "_top"
  }, [_c('h2', {
    staticClass: "_title"
  }, [_vm._v("Send SMS")]), _vm._v(" "), _c('div', {
    staticClass: "_title"
  }, [_vm._v("\n            to "), _c('strong', [_vm._v(_vm._s(_vm._f("formatNumberWithComma")(45678)))]), _vm._v(" SMS\n            contacts\n          ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "post-sms-submit",
    class: {
      onMobile: _vm.onMobile
    }
  }, [_c('div', {
    staticClass: "cursor-pointer",
    on: {
      "click": _vm.closeSMS
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('div', {
    staticClass: "dflex align-center"
  }, [_c('div', {
    staticClass: "char-count mr-2"
  }, [_c('span', {
    class: {
      'red--text': _vm.charCount == _vm.smsMaxChar
    }
  }, [_vm._v(_vm._s(_vm.charCount))]), _vm._v("\n              /\n              "), _c('span', [_vm._v(_vm._s(_vm.smsMaxChar))])]), _vm._v(" "), _c('v-btn', {
    staticClass: "post-sms-btn ma-0",
    attrs: {
      "round": "",
      "depressed": "",
      "dark": ""
    },
    on: {
      "click": _vm.confirmSend
    }
  }, [_c('span', [_vm._v("Send")])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "post-sms-action"
  }, [_c('div', {
    staticClass: "sms-layer sms-input"
  }, [_c('user-tag', {
    attrs: {
      "showAvatar": "",
      "hideName": "",
      "hideTick": "",
      "user": _vm.currentUser,
      "width": "30",
      "height": "30"
    }
  }), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.textMessage),
      expression: "textMessage",
      modifiers: {
        "trim": true
      }
    }],
    ref: "sms",
    staticClass: "sms-input-area",
    attrs: {
      "maxlength": _vm.smsMaxChar,
      "placeholder": "Enter message..."
    },
    domProps: {
      "value": (_vm.textMessage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.textMessage = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })], 1), _vm._v(" "), (!_vm.onMobile) ? _c('div', {
    staticClass: "char-count"
  }, [_c('span', {
    class: {
      'red--text': _vm.charCount == _vm.smsMaxChar
    }
  }, [_vm._v(_vm._s(_vm.charCount))]), _vm._v("\n          /\n          "), _c('span', [_vm._v(_vm._s(_vm.smsMaxChar))])]) : _vm._e()]), _vm._v(" "), _c('attach-slide', {
    staticClass: "mb-0",
    on: {
      "getAttachment": _vm.getSelected
    }
  }), _vm._v(" "), (!_vm.onMobile) ? _c('div', {
    staticClass: "post-sms-submit"
  }, [_c('div', {
    staticClass: "cursor-pointer",
    on: {
      "click": _vm.closeSMS
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    staticClass: "post-sms-btn ma-0",
    attrs: {
      "round": "",
      "depressed": "",
      "dark": ""
    },
    on: {
      "click": _vm.confirmSend
    }
  }, [_c('span', [_vm._v("Send")])])], 1) : _vm._e()], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.confirmSendSMS) ? _c('div', {
    staticClass: "confirm-sms"
  }, [_c('img', {
    staticClass: "cursor-pointer close-icon",
    attrs: {
      "src": require('@/assets/closeIcon.svg'),
      "width": "16"
    },
    on: {
      "click": _vm.closeSMS
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "_title"
  }, [_vm._v("Confirm SMS text")]), _vm._v(" "), _c('img', {
    staticClass: "my-4",
    attrs: {
      "src": require('@/assets/mobile_chat.svg'),
      "width": "35"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "_message"
  }, [_vm._v("\n      This SMS text will be sent to:\n      "), _c('strong', [_vm._v(_vm._s(_vm._f("formatNumberWithComma")(2450)) + " people")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n\n      The credit card connected to this account will be charged $0.01 per\n      text:\n\n      "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('h2', [_vm._v("$24.50")])]), _vm._v(" "), _c('v-btn', {
    staticClass: "width100 mt-3",
    attrs: {
      "dark": "",
      "round": ""
    },
    on: {
      "click": _vm.sendSMS
    }
  }, [_vm._v("Ok, send SMS")])], 1) : _vm._e(), _vm._v(" "), (_vm.onMobile && _vm.sendSuccess) ? _c('div', {
    staticClass: "sms-success"
  }, [_c('img', {
    staticClass: "m2-4",
    attrs: {
      "src": require('@/assets/check_success.svg'),
      "width": "60"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "_title"
  }, [_vm._v("Success")]), _vm._v(" "), _c('div', {
    staticClass: "_message"
  }, [_vm._v("\n      SMS text sent to: "), _c('br'), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm._f("formatNumberWithComma")(2450)) + " people")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-btn', {
    staticClass: "width100 mt-3",
    attrs: {
      "dark": "",
      "depressed": "",
      "round": ""
    },
    on: {
      "click": _vm.openEngagement
    }
  }, [_vm._v("\n      View Engagement\n    ")])], 1) : _vm._e(), _vm._v(" "), (_vm.smsEngagementActive) ? _c('sms-engagement', {
    on: {
      "closeEngagement": _vm.closeEngagement
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("\n        You have "), _c('strong', [_vm._v("2,500")]), _vm._v(" people on your SMS contact list!\n        "), _c('br'), _vm._v("\n        Subscribe to a "), _c('strong', [_vm._v("Pro Plan")]), _vm._v(" to text your content to them\n        directly.\n      ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-57215bed","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SMS/index.vue
// module id = 1729
// module chunks = 180